import React from 'react';
import { 
  Home, 
  FileText, 
  Car, 
  Briefcase, 
  Users, 
  ShieldCheck, 
  Scroll 
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { LegalCategory } from '../types';

const categoryIcons = {
  'tenant-landlord': Home,
  'contract-review': FileText,
  'traffic-tickets': Car,
  'employment': Briefcase,
  'family-law': Users,
  'consumer-protection': ShieldCheck,
  'estate-planning': Scroll,
};

interface CategoryCardProps {
  category: LegalCategory;
  onClick: () => void;
}

export default function CategoryCard({ category, onClick }: CategoryCardProps) {
  const { t } = useTranslation();
  const Icon = categoryIcons[category];

  return (
    <div 
      onClick={onClick}
      className="bg-white rounded-lg shadow-md p-6 cursor-pointer transform transition-all hover:scale-105"
    >
      <div className="flex items-center mb-4">
        <div className="p-2 bg-indigo-100 rounded-lg">
          <Icon className="h-6 w-6 text-indigo-600" />
        </div>
        <h3 className="ml-3 text-lg font-medium text-gray-900">
          {t(`categories.${category}.title`)}
        </h3>
      </div>
      <p className="text-gray-500 text-sm">
        {t(`categories.${category}.description`)}
      </p>
    </div>
  );
}